import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import { TableColumns } from 'helpers/tableColumns';
import { toQueryParams } from 'helpers/url';
import withRouter from 'hoc/withRouter';
import { useRemoteResource } from 'hooks/useRemoteResource';
import { Link } from 'react-router-dom';
import categoriesService from 'services/admin/categoriesService';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (v, i) => i + 1
    },
    {
        key: 'name',
        label: 'Название',
        render: (v) => <a className='color-blue' href={`/superadmin/products/categories?parentID=${v.id}`}>{v.name}</a>
    },
    {
        key: "status",
        label: "Статус",
    },
    {
        key: "",
        label: "Действия",
        render: (v) => <Link className='color-blue' to={`/superadmin/products/categories/add?` + toQueryParams({ parentID: v.id })}>Добавить подкатегорию</Link>
    },
    TableColumns.createdDate,
]

const CategoryList = ({
    router: {
        queryParams
    }
}) => {
    const [data, loadData, loading] = useRemoteResource(() => categoriesService.getAll({ parentID: queryParams.get('parentID') || 0 }), "");

    const onDelete = async (u) => {
        await categoriesService.delete(u.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Категории" pathToAdd={`/superadmin/products/categories/add?parentID=${queryParams.get('parentID') || ''}`}>
            <AppAdminTable
                columnConfig={listConfig}
                data={data.data || []}
                onDelete={onDelete}
                loading={loading}
            />
        </ListPage>
    );
}


export default withRouter(CategoryList);